export default {
    asset_import_instructions: 'Nota Importante: La columna ID es obligatoria. Si el proceso de importación está destinado a actualizar registros existentes, realice una exportación de la tabla sin editar el valor de la columna ID para mantener la referencia del registro. Si desea crear nuevos Activos, deje la columna ID en blanco. Las etiquetas deben estar separadas por un carácter "/". Por ejemplo: Tag1/Tag2/Tag3.',
    importAssets_title: 'Importar activos',
    importAssets_button: 'Importar',
    importAssets_cancel: 'Cancelar',
    importAssets_semicolon: 'Punto y coma (;)',
    importAssets_comma: 'Coma (,)',
    importAssets_selectDelimiter: 'Seleccionar',
    importAssets_delimiter: 'Delimitador',
    importAssets_started: 'La importación se inició correctamente',
    importAssets_error_required: 'El archivo es obligatorio',
    importAssets_error_delimiter: 'El delimitador es obligatorio',
    importAssets_downloadTemplate: 'Descargar plantilla',
    importAssets_file: 'Archivo',
    importAssets_chooseFile: 'Seleccionar archivo',
    importAssets_support_message: 'Solo se admite el formato CSV',
    importAssets_max: 'Máx',
    importAssets_maxSizeFile: 'Tamaño máximo del archivo: 5MB',

    importAssets_template_id: 'ID de Activo',
    importAssets_template_label: 'Etiqueta',
    importAssets_template_type: 'Tipo de activo',
    importAssets_template_subtype: 'Subtipo de activo',
    importAssets_template_externalId: 'ID externo',
    importAssets_template_vin: 'VIN',
    importAssets_template_InspectionDeviceType: 'Dispositivo de inspección',
    importAssets_template_status: 'Estado',
    importAssets_template_tags: 'Etiquetas',
    importAssets_template_make: 'Marca',
    importAssets_template_model: 'Modelo',
    importAssets_template_year: 'Año',
    importAssets_template_InspectionTagId: 'ID de etiqueta de inspección',
    importAssets_template_powerUnitNumber: 'Número de unidad de potencia',
    importAssets_template_maintenanceCompany: 'Compañía de mantenimiento',
    importAssets_template_registrationCountry: 'País de registro',
    importAssets_template_registrationState: 'Estado de registro',
    importAssets_template_registrationExpiration: 'Expiración de registro',
    importAssets_template_engineSerialNumber: 'Número de serie del motor',
    importAssets_template_chassisSerialNumber: 'Número de serie del chasis',
    importAssets_template_licensePlate: 'Matrícula',

    assets_import_error_CA01: 'Archivo CSV vacío: El archivo no contiene filas de datos. Por favor, agregue al menos una fila con información del activo.',
    assets_import_error_CA02: 'Error en el formato CSV: La columna ID del activo es obligatoria para las actualizaciones de activos.',
    assets_import_error_CA03: 'No se encontraron filas de datos válidas: Las columnas ID y Nombre del activo no pueden estar vacías en todas las filas.',
    assets_import_error_CA04: 'Error en el formato CSV: La columna Tipo de activo es obligatoria para las actualizaciones de activos.',
    assets_import_error_CA05: 'Error en el formato CSV: La columna Subtipo de activo es obligatoria para las actualizaciones de activos.',
};